import { useMemo, useState } from "react";
import {
  CONTENT_CARD_TYPE,
  CONTENT_CATEGORY_TYPE,
  CONTENT_STORE_TYPE,
  ContentCardType,
  ContentCategoryType,
  ContentStoreType,
  ContentType,
  OwnerSectionType,
  WebStoreSelectorType,
} from "../../controller/MasterController";
import { contentName } from "../../utils/util";
import CardContent from "./content/cardContent";
import CategoryContent from "./content/categoryContent";
import StoreContent from "./content/storeContent";

interface MasterStoreProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  currentDate: Date;
  navigateSector: any;
  openCard: any;
}

const MasterStore = ({
  storeList,
  lang,
  currentDate,
  navigateSector,
  openCard,
}: MasterStoreProps) => {
  const [masterStoreIndex, setMasterStoreIndex] = useState<number>(0);

  const MasterStore = useMemo(() => {
    return storeList?.owner_section && storeList?.owner_section?.length > 0 ? (
      <div className="directlyStoreWrap">
        <div className="row">
          {storeList?.owner_section?.map(
            (owner: OwnerSectionType, index: number) => {
              return (
                <button
                  key={index}
                  className={`typeButton 
                       ${masterStoreIndex === index && "active"}`}
                  onClick={() => setMasterStoreIndex(index)}
                >
                  {contentName(owner.content_name, lang)}
                  <div className="bar"></div>
                </button>
              );
            }
          )}
        </div>
        <div className="scrollWrap">
          {storeList?.owner_section[masterStoreIndex].content.map(
            (item: ContentType, index: number) => {
              return item.content_type === CONTENT_STORE_TYPE ? (
                <StoreContent
                  key={index}
                  item={item as ContentStoreType}
                  currentDate={currentDate}
                  navigateSector={navigateSector}
                  type={"owner"}
                />
              ) : item.content_type === CONTENT_CATEGORY_TYPE ? (
                <CategoryContent
                  key={index}
                  item={item as ContentCategoryType}
                  navigateSector={() => {}}
                />
              ) : (
                item.content_type === CONTENT_CARD_TYPE && (
                  <CardContent
                    key={index}
                    item={item as ContentCardType}
                    navigateSector={openCard}
                  />
                )
              );
            }
          )}
        </div>
      </div>
    ) : (
      <div />
    );
  }, [storeList, masterStoreIndex, lang, currentDate]);

  return MasterStore;
};
export default MasterStore;
